import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { grey2, grey5 } from 'approot/shared/styles/colours.style';
import {
  FlexLeftAlign,
  flexCentreAlignCss,
} from 'approot/shared/styles/flex.style';
import {
  spacing12,
  spacing16,
  spacing8,
} from 'approot/shared/styles/spacing.style';
import { SecondaryBaseStyled } from 'approot/shared/styles/buttons/secondary-button.style';
import { font16 } from 'approot/shared/styles/typography.style';

export const VocabularyListItem = styled.li`
  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius8)};
  margin-bottom: ${rem(spacing16)};
  position: relative;
`;

export const VocabularyListContent = styled.div`
  border-radius: ${rem(borderRadius8)};
  display: flex;
  justify-content: space-between;
  align-items: start;
  padding: ${rem(spacing12)};
`;

export const VocabularyListButtonAction = styled.div`
  display: flex;
  gap: ${rem(spacing8)};
  position: relative;
  z-index: 2;
`;

export const VocabularyImagePicture = styled.div`
  ${flexCentreAlignCss}
  background-color: ${grey2};
  border-radius: ${rem(borderRadius8)};
  border: 1px solid ${grey5};
  width: ${rem(40)};
  height: ${rem(40)};

  svg path {
    stroke: ${grey5};
  }
`;

export const VocabularyListButtonTrigger = styled.button`
  ${SecondaryBaseStyled}

  background: none;
  border: none;
  border-radius: ${rem(8)};
  height: auto;
  padding: 0;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;

  &:hover,
  &:focus {
    background: none;
    cursor: pointer;
    & + ${VocabularyListContent} {
      background-color: ${grey2};
    }
  }
`;

export const VocabularyListDetails = styled.div`
  display: flex;
`;

export const VocabularyListData = styled.div`
  ${font16}
`;

export const VocabularyLanguage = styled(FlexLeftAlign)`
  gap: ${rem(spacing8)};
  margin-top: ${rem(spacing8)};
`;
